import React, { useState } from "react";
import "./temperature.css";

export default function Temperature(props) {
  const [unit, setUnit] = useState("celsius");

  function showFahreneit(event) {
    event.preventDefault();
    setUnit("fahrenheit");
  }
  function showCelsius(event) {
    event.preventDefault();
    setUnit("celsius");
  }
  if (unit === "celsius") {
    return (
      <div>
        <span className="temperature">{props.unit}</span>
        <span id="unit">
          ℃ |
          <a href="/" onClick={showFahreneit}>
            ℉
          </a>
        </span>
      </div>
    );
  } else {
    let fahrenheit = (props.unit * 9) / 5 + 32;
    return (
      <div>
        <span className="temperature">{Math.round(fahrenheit)}</span>
        <span id="unit">
          <a href="/" onClick={showCelsius}>
            ℃
          </a>
          | ℉
        </span>
      </div>
    );
  }
}
